import React, { forwardRef, useRef } from 'react';
import { isTouchScreen } from "../../../lib/elementUtilities";

const Stat = (props) => {
  const divRef = useRef();

  return (
    <div className="stat"
         ref={divRef}
         onMouseEnter={() => props.hover && !isTouchScreen() && props.hover(divRef)}
         onMouseOver={() => props.hover && !isTouchScreen() && props.hover(divRef)}
         onMouseLeave={props.hoverOut && !isTouchScreen() && props.hoverOut}
         onClick={() => (props.click && props.click(divRef))
           || (isTouchScreen() && props.hover(divRef))}
    >
      <i className={`icon icon-xmd icon-${props.iconClass}`}/>
      <span className="value">
        <span className={props.limitReached ? "negative" : ""}>
          {props.resourceAmount || 0}
          {props.resourceBalance !== undefined
          && <strong
            className={`${props.resourceBalance < 0 ? "negative" : ((props.resourceBalanceEffective !== false && "positive") || "yellow")}`}>
            &nbsp;({props.resourceBalance})
          </strong>}
        </span>
      </span>
    </div>
  )
};

export default forwardRef(Stat);
